module.exports = __webpack_public_path__ + "img/2-1.85533a55.png";